// extracted by mini-css-extract-plugin
var _1 = "_customerManagement-module__button-container";
var _2 = "_customerManagement-module__title";
export { _1 as "button-container", _2 as "title" }
